<div class="min-h-screen animate-pulse bg-openflis-10 text-gray-900" role="status" aria-live="polite">
    <span class="sr-only">Loading account workspace</span>

    <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
        <div class="flex grow flex-col gap-y-5 overflow-hidden border-r-2 border-r-gray-200 bg-white px-6 pb-4">
            <div class="flex h-16 shrink-0 items-center">
                <img
                    class="h-8 w-auto"
                    src="/assets/img/logo.svg"
                    alt="OpenFLIS"
                />
            </div>

            <nav class="flex flex-1 flex-col">
                <ul role="list" class="flex flex-1 flex-col gap-y-7">
                    <li>
                        <ul role="list" class="-mx-2 space-y-1">
                            <li>
                                <div class="flex gap-x-3 rounded-md bg-openflis-100 p-2">
                                    <div class="h-6 w-6 shrink-0 rounded bg-openflis-200"></div>
                                    <div class="h-5 w-20 rounded bg-openflis-200"></div>
                                </div>
                            </li>
                            <li>
                                <div class="flex gap-x-3 rounded-md p-2">
                                    <div class="h-6 w-6 shrink-0 rounded bg-gray-200"></div>
                                    <div class="h-5 w-28 rounded bg-gray-200"></div>
                                </div>
                            </li>
                            <li>
                                <div class="flex gap-x-3 rounded-md p-2">
                                    <div class="h-6 w-6 shrink-0 rounded bg-gray-200"></div>
                                    <div class="h-5 w-32 rounded bg-gray-200"></div>
                                </div>
                            </li>
                        </ul>
                    </li>

                    <li class="mt-auto space-y-2">
                        <div class="flex gap-x-3 rounded-md p-2">
                            <div class="h-6 w-6 shrink-0 rounded bg-gray-200"></div>
                            <div class="h-5 w-20 rounded bg-gray-200"></div>
                        </div>
                        <div class="flex gap-x-3 rounded-md p-2">
                            <div class="h-6 w-6 shrink-0 rounded bg-gray-200"></div>
                            <div class="h-5 w-16 rounded bg-gray-200"></div>
                        </div>
                    </li>
                </ul>
            </nav>
        </div>
    </div>

    <div class="flex min-h-screen flex-col lg:pl-72">
        <header class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <div class="lg:hidden">
                <img
                    class="h-8 w-auto"
                    src="/assets/img/logo.svg"
                    alt="OpenFLIS"
                />
            </div>

            <div class="h-6 w-px bg-gray-200 lg:hidden"></div>

            <div class="flex flex-1 items-center justify-end gap-x-4">
                <div class="hidden h-8 w-48 rounded-md bg-gray-200 sm:block"></div>
                <div class="h-9 w-9 rounded-full bg-gray-200"></div>
            </div>
        </header>

        <main class="flex-1 overflow-hidden">
            <div class="px-5 py-5">
                <div class="mb-3 flex items-center justify-between">
                    <div class="h-9 w-36 rounded bg-gray-200 sm:w-44"></div>
                </div>

                <div class="grid grid-cols-1 justify-center gap-6 pt-2 pb-10 sm:grid-cols-2 sm:px-2 xl:px-32">
                    <div class="overflow-hidden rounded-lg bg-white p-4 shadow">
                        <div class="mx-auto h-7 w-52 rounded bg-gray-200"></div>
                        <div class="mx-auto mt-5 h-9 w-36 rounded bg-openflis-100"></div>
                        <div class="mx-auto mt-5 h-5 w-60 max-w-full rounded bg-gray-200"></div>
                    </div>

                    <div class="overflow-hidden rounded-lg bg-white p-4 shadow">
                        <div class="mx-auto h-7 w-64 max-w-full rounded bg-gray-200"></div>
                        <div class="mx-auto mt-5 h-9 w-24 rounded bg-openflis-100"></div>
                        <div class="mx-auto mt-5 h-5 w-32 rounded bg-gray-200"></div>
                    </div>
                </div>

                <div class="relative mb-5 grid grid-cols-1 gap-y-5 md:grid-cols-[1fr_auto]">
                    <div class="h-12 rounded-md bg-white px-4 py-3">
                        <div class="flex items-center gap-3">
                            <div class="h-5 w-5 rounded bg-gray-200"></div>
                            <div class="h-5 w-72 max-w-[70%] rounded bg-gray-200"></div>
                        </div>
                    </div>

                    <div class="flex md:ml-3">
                        <div class="h-12 w-40 rounded-md bg-openflis-200"></div>
                    </div>
                </div>

                <div class="hidden h-12 grid-cols-6 px-2 py-4 md:grid">
                    <div class="col-span-2 h-4 w-16 rounded bg-openflis-100"></div>
                    <div class="col-span-2 h-4 w-16 rounded bg-openflis-100"></div>
                    <div class="col-span-1 h-4 w-14 rounded bg-openflis-100"></div>
                    <div class="col-span-1 mx-auto h-4 w-16 rounded bg-openflis-100"></div>
                </div>

                <div class="space-y-2">
                    <div class="grid min-h-20 grid-cols-1 items-center rounded-lg border border-white bg-white px-2 py-4 md:grid-cols-6">
                        <div class="col-span-2 flex items-center pr-3">
                            <div class="h-5 w-40 rounded bg-gray-200"></div>
                        </div>
                        <div class="col-span-2 flex items-center py-3 md:py-0">
                            <div class="h-5 w-56 max-w-full rounded bg-gray-200"></div>
                        </div>
                        <div class="col-span-1 flex items-center gap-2">
                            <div class="h-2.5 w-2.5 rounded-full bg-gray-300"></div>
                            <div class="h-5 w-16 rounded bg-gray-200"></div>
                        </div>
                        <div class="col-span-1 mt-4 flex justify-start gap-3 md:mt-0 md:justify-center">
                            <div class="h-6 w-6 rounded bg-gray-200"></div>
                            <div class="h-6 w-6 rounded bg-gray-200"></div>
                            <div class="h-6 w-6 rounded bg-gray-200"></div>
                        </div>
                    </div>

                    <div class="grid min-h-20 grid-cols-1 items-center rounded-lg border border-white bg-white px-2 py-4 md:grid-cols-6">
                        <div class="col-span-2 flex items-center pr-3">
                            <div class="h-5 w-32 rounded bg-gray-200"></div>
                        </div>
                        <div class="col-span-2 flex items-center py-3 md:py-0">
                            <div class="h-5 w-48 max-w-full rounded bg-gray-200"></div>
                        </div>
                        <div class="col-span-1 flex items-center gap-2">
                            <div class="h-2.5 w-2.5 rounded-full bg-gray-300"></div>
                            <div class="h-5 w-20 rounded bg-gray-200"></div>
                        </div>
                        <div class="col-span-1 mt-4 flex justify-start gap-3 md:mt-0 md:justify-center">
                            <div class="h-6 w-6 rounded bg-gray-200"></div>
                            <div class="h-6 w-6 rounded bg-gray-200"></div>
                            <div class="h-6 w-6 rounded bg-gray-200"></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</div>
